import React, { useState, useEffect, useContext } from "react";
import { serverHost } from "variables/serverdata";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
} from "react-bootstrap";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { Input } from "reactstrap";
import HusariaHeader from "views/pages/components/HusariaHeader";

const RinggroupAddEdit = ({ method }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const { id } = useParams();
  const navigate = useNavigate();
  const dialplans = [
    { value: "transfer:*98 XML 10.0.190.48", label: "Check Voicemail" },
    { value: "transfer:*411 XML 10.0.190.48", label: "Company Directory" },
    { value: "hangup:", label: "Hangup" },
    { value: "transfer:*732 XML 10.0.190.48", label: "Record" },
  ];
  const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
  const site_uuid = currentSite?.domain_uuid || null;
  const [error, setError] = useState("");
  const [destinations, setDestinations] = useState([
    {
      destination_uuid: null,
      destination: "",
      delay: null,
      timeout: 30,
      prompt: null,
      description: "",
      enabled: false,
    },
  ]);
  const [users, setUsers] = useState([
    {
      username: null,
      user_uuid: null,
    },
  ]);
  const [showEmailField, setShowEmailField] = useState(false);
  const [showForwardField, setShowForwardField] = useState(false);
  const [extensionList, setExtensionList] = useState([]);
  const [bridgeList, setBridgeList] = useState([]);
  const [voicemailList, setVoicemailList] = useState([]);
  const [tonesList, setTonesList] = useState([]);
  const [flowsList, setFlowsList] = useState([]);
  const [ivrList, setIVRList] = useState([]);
  const [timeConditionsList, setTCList] = useState([]);
  const [destinationsList, setDestList] = useState([]);
  const [ringGroupList, setRingGroup] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [recordingsList, setRecordingsList] = useState([]);
  const [ringtonesList, setRingtonesList] = useState([]);
  const [formData, setFormData] = useState({
    ring_group_name: "",
    ring_group_extension: "",
    ring_group_greeting: "",
    ring_group_strategy: "",
    timeout_destination: "",
    ring_group_call_timeout: 30,
    ring_group_caller_id_name: "",
    ring_group_caller_id_number: "",
    ring_group_distinctive_ring: "",
    ring_group_ringback: "",
    userlist: "",
    ring_group_call_screen_enabled: false,
    ring_group_call_forward_enabled: false,
    ring_group_follow_me_enabled: false,
    ring_group_missed_call_app: "",
    ring_group_missed_call_data: "",
    ring_group_forward_enabled: false,
    ring_group_forward_destination: "",
    ring_group_forward_toll_allow: "",
    ring_group_context: "",
    ring_group_enabled: true,
    ring_group_description: "",
  });

  // Mock dropdown options
  const greetingOptions = [
    { value: "", label: "Select..." },
    { value: "greeting1", label: "Greeting 1" },
    { value: "greeting2", label: "Greeting 2" },
  ];

  const strategyOptions = [
    { value: "", label: "Select..." },
    { value: "enterprise", label: "Enterprise" },
    { value: "random", label: "Random" },
    { value: "rollover", label: "Rollover" },
    { value: "sequence", label: "Sequence" },
    { value: "simultaneous", label: "Simultaneous" },
  ];

  const promptOptions = [
    { value: null, label: "Select..." },
    { value: 1, label: "Confirm" },
  ];

  const ringbackOptions = [
    { value: "", label: "Select..." },
    { value: "default", label: "Default" },
    { value: "music", label: "Music" },
  ];

  const missedCallOptions = [
    { value: "", label: "Select..." },
    { value: "email", label: "Email" },
    { value: "sms", label: "SMS" },
    { value: "none", label: "None" },
  ];
  useEffect(() => {
    const fetchDomain = async (e) => {
      try {
        const currentSite = JSON.parse(localStorage.getItem("selectedSite"));
        const domain_uuid = currentSite?.site_uuid || null;
        const response = await fetch(
          `${serverHost}/fetch_domain_name/${domain_uuid}`
        );
        if (!response.ok) throw new Error(`Failed to fetch domain context`);
        const data = await response.json();
        setFormData((prev) => ({ ...prev, ring_group_context: data.result }));
      } catch (err) {
        setError(err.message);
      }
    };
    const endpoints = {
      users: {
        url: `${serverHost}/get_rows?table=v_users&pageSize=50&page=1`,
        map: (u) => ({
          user_uuid: u.user_uuid,
          name: u.username,
        }),
        setter: setUsersList,
      },
      extensions: {
        url: `${serverHost}/get_rows?table=v_extensions&pageSize=50&page=1`,
        map: (e) => ({
          extension_uuid: e.extension_uuid,
          name: e.extension,
          accountcode: e.accountcode,
        }),
        setter: setExtensionList,
      },
      bridges: {
        url: `${serverHost}/get_rows?table=v_bridges&pageSize=50&page=1`,
        map: (b) => ({
          destination: b.bridge_destination,
          bridge_uuid: b.bridge_uuid,
          name: b.bridge_name,
        }),
        setter: setBridgeList,
      },
      voicemails: {
        url: `${serverHost}/get_rows?table=v_voicemails&pageSize=50&page=1`,
        map: (r) => ({
          voicemail_uuid: r.voicemail_uuid,
          voicemail_id: r.voicemail_id,
          value: `*99${r.voicemail_id} XML ${r.accountcode}`,
        }),
        setter: setVoicemailList,
      },
      tones: {
        url: `${serverHost}/get_rows?table=v_vars&pageSize=50&page=1&cfilter=var_category&vfilter=Tones`,
        map: (r) => ({
          value: r.var_value,
          name: r.var_name,
        }),
        setter: setTonesList,
      },
      flows: {
        url: `${serverHost}/get_rows?table=v_call_flows&pageSize=50&page=1`,
        map: (f) => ({
          value: `${f.call_flow_extension} XML ${f.call_flow_context}`,
          name: `${f.call_flow_extension} ${f.call_flow_name}`,
        }),
        setter: setFlowsList,
      },
      ivr: {
        url: `${serverHost}/get_rows?table=v_ivr_menus&pageSize=50&page=1`,
        map: (v) => ({
          value: v.ivr_menu_uuid,
          transfer: `${v.ivr_menu_extension} XML ${v.ivr_menu_context}`,
          name: v.ivr_menu_name,
        }),
        setter: setIVRList,
      },
      time_conditions: {
        url: `${serverHost}/fetch_time_conditions`,
        map: (tc) => ({
          value: `${tc.dialplan_number} XML ${tc.dialplan_context}`,
          name: `${tc.dialplan_number} ${tc.dialplan_name}`,
        }),
        setter: setTCList,
      },
      destinations: {
        url: `${serverHost}/fetch_destinations`,
        map: (d) => ({
          value: `${d.destination_number} XML ${d.destination_context}`,
          name: `${d.destination_number}${
            d.destination_description ? " " + d.destination_description : ""
          }`,
        }),
        setter: setDestList,
      },
      ringgroups: {
        url: `${serverHost}/get_rows?table=v_ring_groups&pageSize=50&page=1`,
        map: (r) => ({
          value: `transfer ${r.ring_group_extension} XML ${r.ring_group_context}`,
          name: `${r.ring_group_extension} ${r.ring_group_name}`,
        }),
        setter: setRingGroup,
      },
    };

    const fetchData = async () => {
      for (const key in endpoints) {
        const { url, map, setter } = endpoints[key];
        try {
          const res = await fetch(url);
          if (!res.ok) continue;

          const data = await res.json();
          const mapped = data.results.map(map);
          console.log(key, mapped);

          setter(mapped);
        } catch (err) {
          console.error(`Failed to fetch ${key}:`, err);
        }
      }
    };

    const fetchRinggroup = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_row?table=v_ring_groups&pk=ring_group_uuid&id=${encodeURIComponent(
            id
          )}`
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Row not found" : "Failed to fetch row"
          );
        const data = await res.json();
        if (!data?.result) throw new Error("Row not found");
        const rg = data.result;
        setFormData({
          ...rg,
          timeout_destination: `${rg.ring_group_timeout_app}:${rg.ring_group_timeout_data}`,
          userlist: "",
          ring_group_call_screen_enabled:
            rg.ring_group_call_screen_enabled === "true",
          ring_group_call_forward_enabled:
            rg.ring_group_call_forward_enabled === "true",
          ring_group_follow_me_enabled:
            rg.ring_group_follow_me_enabled === "true",
          ring_group_forward_enabled: rg.ring_group_forward_enabled === "true",
          ring_group_enabled: rg.ring_group_enabled === "true",
        });
      } catch (err) {
        console.log("Failed to fetch ring group ", err);
        setError("Failed to fetch Ring Group: ", err);
      }
    };
    const fetchDestinations = async () => {
      try {
        const res = await fetch(
          `${serverHost}/fetch_rg_destinations/${encodeURIComponent(id)}`
        );
        if (!res.ok)
          throw new Error(
            res.status === 404 ? "Row not found" : "Failed to fetch row"
          );
        const data = await res.json();
        if (!data?.result) throw new Error("Row not found");
        const rg_dest = data.result;
        const dest_list = rg_dest.map((d) => ({
          destination_uuid: d.ring_group_destination_uuid,
          destination: d.destination_number,
          delay: d.destination_delay,
          timeout: d.destination_timeout,
          prompt: d.destination_prompt,
          description: d.destination_description,
          enabled: d.destination_enabled,
        }));
        setDestinations(dest_list);
      } catch (err) {
        console.log("Failed to fetch destinations ", err);
        setError("Failed to fetch dest error ", err);
      }
    };

    const fetchRecordings = async (e) => {
      try {
        const domain_uuid = currentSite?.site_uuid || null;
        const response = await fetch(
          `${serverHost}/get_recordings/${domain_uuid}`,
        );
        if (!response.ok) throw new Error(`Failed to fetch domain context`);
        const data = await response.json();
        console.log(data);
        setRecordingsList(data.results || []);
      } catch (err) {
        setError(err.message);
      }
    };
    const fetchRingtones = async () => {
      try {
        const res = await fetch(
          `${serverHost}/get_rows?table=v_vars&pageSize=50&page=1&cfilter=var_category&vfilter=Ringtones`,
        );
        if (res.ok) {
          const data = await res.json();
          console.log(data);
          const tones = data.results.map((r) => ({
            value: `\${${r.var_name}}`,
            name: r.var_name,
          }));
          console.log(tones);
          setRingtonesList(tones);
        }
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };


    const fetchUsers = async () => {};

    fetchData();
    if (method === "edit") {
      fetchRecordings();
      fetchRingtones();
      fetchRinggroup();
      fetchDestinations();
      fetchUsers();
    } else {
      fetchDomain();
    }
  }, []);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));

    if (name === "missed_call") {
      setShowEmailField(value === "email");
    }
    if (name === "ring_group_forward_enabled") {
      setShowForwardField(checked);
    }
  };

  const handleDestinationChange = (index, field, value) => {
    const newDestinations = [...destinations];
    newDestinations[index][field] = value;
    setDestinations(newDestinations);
  };

  const addDestination = () => {
    if (destinations.length < 5) {
      setDestinations([
        ...destinations,
        {
          destination_uuid: null,
          destination: "",
          delay: "",
          timeout: "",
          prompt: "",
          description: "",
          enabled: true,
        },
      ]);
    }
  };

  const removeDestination = (index) => {
    if (destinations.length > 1) {
      const newDestinations = destinations.filter((_, i) => i !== index);
      setDestinations(newDestinations);
    }
  };

  const handleSubmit = async (e) => {
    console.log("Submitting!");
    if (
      !formData.ring_group_name ||
      !formData.ring_group_extension ||
      !formData.ring_group_strategy ||
      !formData.ring_group_call_timeout
    ) {
      setError("Please fill in all required fields");
      return;
    }

    console.log("Form Data:", formData);
    console.log("Destinations:", destinations);

    try {
      const site = JSON.parse(localStorage.getItem("selectedSite"));
      const payload = {
        data: {
          ...formData,
        },
        destinations: destinations,
        client_uuid: site.client_uuid,
        site_name: site.company_name,
        insert_uuid: JSON.parse(localStorage.getItem("user")).user_uuid,
      };
      let url = `${serverHost}/ring_group/${site.site_uuid}`;
      if (method === "edit") {
        url = `${serverHost}/edit_ring_group/${encodeURIComponent(id)}`;
        payload.site_uuid = site.site_uuid;
      }
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        // Show success message
        navigate("/admin/hucs/ring-groups"); // Navigate back to call flows list
      } else {
        const error = await response.json();
        console.error("Failed to create call ring group:", error);
        // Show error message
        setError("Failed to create ring group, ", error);
      }
    } catch (err) {
      setError("Failed to create Ring Group - ", err);
    }
  };

  const handleCancel = () => {
    navigate("/admin/hucs/ring-groups");
  };

  const inputStyle = {
    width: "100%",
    padding: "0.5rem 0.75rem",
    fontSize: "1rem",
    lineHeight: "1.5",
    borderRadius: "0.25rem",
    border: "1px solid",
    backgroundColor: isDark ? "#374151" : "#fff",
    color: isDark ? "#e2e8f0" : "#495057",
    borderColor: isDark ? "#4b5563" : "#ced4da",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "0.5rem",
    color: isDark ? "#e2e8f0" : "#495057",
    fontWeight: 500,
  };

  const cardStyle = {
    backgroundColor: isDark ? "#374151" : "#f8f9fa",
    border: "1px solid",
    borderColor: isDark ? "#4b5563" : "#dee2e6",
    borderRadius: "0.25rem",
    padding: "1rem",
    marginBottom: "1rem",
  };

  return (
    <>
      <HusariaHeader name="Ring Group" parentName="HUCS" padding="4.5rem" />
      <Container fluid className="mt--6">
        <Card className="shadow-sm" style={{ border: "none" }}>
          <Card.Header
            style={{
              backgroundColor: isDark ? "#1f2937" : "#e9ecef",
              color: isDark ? "#e2e8f0" : "#1e3a5f",
              borderBottom: "none",
              padding: "1rem 1.5rem",
            }}
          >
            <h5 className="mb-0" style={{ fontWeight: 600 }}>
              {method.toUpperCase()} RING GROUP
            </h5>
          </Card.Header>

          <Card.Body>
            {error && (
              <Alert variant="danger" className="d-flex align-items-center">
                <span>! {error}</span>
              </Alert>
            )}

            {/* Basic Information */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-bold">
                    Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_name"
                    value={formData.ring_group_name}
                    onChange={handleChange}
                    placeholder="Enter ring group name"
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-bold">
                    Extension <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_extension"
                    value={formData.ring_group_extension}
                    onChange={handleChange}
                    placeholder="Enter extension number"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Greeting</Form.Label>
                  <Input
                    type="select"
                    name="ring_group_greeting"
                    value={formData.ring_group_greeting}
                    onChange={handleChange}
                  >
                    {greetingOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Input>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-bold">
                    Strategy <span className="text-danger">*</span>
                  </Form.Label>
                  <Input
                    type="select"
                    name="ring_group_strategy"
                    value={formData.ring_group_strategy}
                    onChange={handleChange}
                    required
                  >
                    {strategyOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Input>
                </Form.Group>
              </Col>
            </Row>

            {/* Destinations Section */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <Form.Label className="fw-bold mb-0">
                  Destinations <span className="text-danger">*</span>
                </Form.Label>
                {destinations.length < 5 && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={addDestination}
                  >
                    + Add Destination
                  </Button>
                )}
              </div>

              {destinations.map((dest, index) => (
                <Card key={index} className="mb-3">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <strong>Destination {index + 1}</strong>
                      {destinations.length > 1 && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => removeDestination(index)}
                        >
                          x
                        </Button>
                      )}
                    </div>

                    <Row className="mb-2">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label
                            className="fw-bold"
                            style={{ fontSize: "0.9rem" }}
                          >
                            Destination{" "}
                            {index === 0 && (
                              <span className="text-danger">*</span>
                            )}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={dest.destination}
                            onChange={(e) =>
                              handleDestinationChange(
                                index,
                                "destination",
                                e.target.value
                              )
                            }
                            placeholder="Enter destination"
                            required={index === 0}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group>
                          <Form.Label style={{ fontSize: "0.9rem" }}>
                            Delay
                          </Form.Label>
                          <Form.Control
                            type="number"
                            value={dest.delay}
                            required={index === 0}
                            onChange={(e) =>
                              handleDestinationChange(
                                index,
                                "delay",
                                e.target.value
                              )
                            }
                            placeholder="0"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group>
                          <Form.Label style={{ fontSize: "0.9rem" }}>
                            Timeout
                          </Form.Label>
                          <Form.Control
                            type="number"
                            value={dest.timeout}
                            required={index === 0}
                            onChange={(e) =>
                              handleDestinationChange(
                                index,
                                "timeout",
                                e.target.value
                              )
                            }
                            placeholder="30"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label style={{ fontSize: "0.9rem" }}>
                            Prompt
                          </Form.Label>
                          <Input
                            type="select"
                            value={dest.prompt}
                            required={index === 0}
                            onChange={(e) =>
                              handleDestinationChange(
                                index,
                                "prompt",
                                e.target.value
                              )
                            }
                          >
                            {promptOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </Input>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label style={{ fontSize: "0.9rem" }}>
                            Description
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={dest.description}
                            onChange={(e) =>
                              handleDestinationChange(
                                index,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group>
                      <div className="d-flex align-items-center gap-2">
                        <span>Enabled</span>
                        <label className="custom-toggle mb-0">
                          <input
                            type="checkbox"
                            name="bridge_enabled"
                            checked={dest.enabled}
                            onChange={(e) =>
                              handleDestinationChange(
                                index,
                                "enabled",
                                e.target.checked
                              )
                            }
                          />
                          <span
                            className="custom-toggle-slider rounded-circle"
                            data-label-off="Off"
                            data-label-on="On"
                          />
                        </label>
                      </div>
                    </Form.Group>
                  </Card.Body>
                </Card>
              ))}
            </div>

            {/* Call Settings */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Timeout Destination</Form.Label>
                  <Input
                  type="select"
                    name="timeout_destination"
                    value={formData.timeout_destination}
                    onChange={handleChange}
                  >
                    <option value="">Select...</option>
                    <optgroup label="Bridges">
                      {bridgeList.map((br) => (
                        <option
                          key={br.bridge_uuid}
                          value={`bridge:${br.destination}`}
                        >
                          {br.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Call Flows">
                      {flowsList.map((cf) => (
                        <option key={cf.name} value={`transfer:${cf.value}`}>
                          {cf.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Destinations">
                      {destinationsList.map((d) => (
                        <option value={`transfer:${d.value}`}>{d.name}</option>
                      ))}
                    </optgroup>
                    <optgroup label="Extensions">
                      {extensionList.map((ext) => (
                        <option
                          key={ext.extension_uuid}
                          value={`transfer:${ext.name} XML ${ext.accountcode}`}
                        >
                          {ext.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="IVR Menus">
                      {ivrList.map((ivr) => (
                        <option key={ivr.name} value={`transfer:${ivr.value}`}>
                          {ivr.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Ring Groups">
                      {ringGroupList.map((rg) => (
                        <option value={`transfer:${rg.value}`}>
                          {rg.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Time Conditions">
                      {timeConditionsList.map((tc) => (
                        <option key={tc.name} value={`transfer:${tc.value}`}>
                          {tc.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Tones">
                      {tonesList.map((tone) => (
                        <option
                          key={tone.name}
                          value={`playback:tone_stream://${tone.value}`}
                        >
                          {tone.name}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Voicemails">
                      {voicemailList.map((vm) => (
                        <option
                          key={vm.voicemail_uuid}
                          value={`transfer:${vm.value}`}
                        >
                          {vm.voicemail_id}
                        </option>
                      ))}
                    </optgroup>
                    <optgroup label="Dialplans">
                      {dialplans.map((dp) => (
                        <option key={dp.value} value={dp.value}>
                          {dp.label}
                        </option>
                      ))}
                    </optgroup>
                  </Input>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-bold">
                    Call Timeout <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_call_timeout"
                    value={formData.ring_group_call_timeout}
                    onChange={handleChange}
                    placeholder="Enter timeout in seconds"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Caller ID Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_caller_id_name"
                    value={formData.ring_group_caller_id_name}
                    onChange={handleChange}
                    placeholder="Enter caller ID name"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Caller ID Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_caller_id_number"
                    value={formData.ring_group_caller_id_number}
                    onChange={handleChange}
                    placeholder="Enter caller ID number"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Distinctive Ring</Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_distinctive_ring"
                    value={formData.ring_group_distinctive_ring}
                    onChange={handleChange}
                    placeholder="Enter distinctive ring"
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>Ringback</Form.Label>
                  <Input
                  type="select"
                    name="ring_group_ringback"
                    value={formData.ring_group_ringback}
                    onChange={handleChange}
                  >
                    <option value="">Select...</option>
                      <optgroup label="Music On Hold">
                        <option
                          value="local_stream://default"
                          selected="selected"
                        >
                          default
                        </option>
                      </optgroup>
                      <optgroup label="Recordings">
                        {recordingsList.map((opt) => (
                          <option
                            key={opt.recording_filename}
                            value={opt.recording_filename}
                          >
                            {opt.recording_name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Ringtones">
                        {ringtonesList.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.name}
                          </option>
                        ))}
                      </optgroup>
                      <optgroup label="Tones">
                        {tonesList.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.name}
                          </option>
                        ))}
                      </optgroup>
                  </Input>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>User List</Form.Label>
                  <Input
                  type="select"
                    name="userlist"
                    value={formData.userlist}
                    onChange={handleChange}
                  >
                    <option key="empty" value="none">
                      {" "}
                    </option>
                    {usersList.map((opt) => (
                      <option key={opt.user_uuid} value={opt.user_uuid}>
                        {opt.name}
                      </option>
                    ))}
                  </Input>
                </Form.Group>
              </Col>
            </Row>

            {/* Feature Toggles */}
            <Row className="mb-3">
              <Col md={3}>
                <div className="d-flex align-items-center gap-2">
                  <span>Call Screen</span>
                  <label className="custom-toggle mb-0">
                    <input
                      type="checkbox"
                      id="ring_group_call_screen_enabled"
                      name="ring_group_call_screen_enabled"
                      checked={formData.ring_group_call_screen_enabled}
                      onChange={handleChange}
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off="Off"
                      data-label-on="On"
                    />
                  </label>
                </div>
              </Col>

              <Col md={3}>
                <div className="d-flex align-items-center gap-2">
                  <span>Call Forward</span>
                  <label className="custom-toggle mb-0">
                    <input
                      type="checkbox"
                      id="ring_group_call_forward_enabled"
                      name="ring_group_call_forward_enabled"
                      checked={formData.ring_group_call_forward_enabled}
                      onChange={handleChange}
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off="Off"
                      data-label-on="On"
                    />
                  </label>
                </div>
              </Col>

              <Col md={3}>
                <div className="d-flex align-items-center gap-2">
                  <span>Follow Me</span>
                  <label className="custom-toggle mb-0">
                    <input
                      type="checkbox"
                      id="ring_group_follow_me_enabled"
                      name="ring_group_follow_me_enabled"
                      checked={formData.ring_group_follow_me_enabled}
                      onChange={handleChange}
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off="Off"
                      data-label-on="On"
                    />
                  </label>
                </div>
              </Col>

              <Col md={3}>
                <div className="d-flex align-items-center gap-2">
                  <span>Ring Group Forward</span>
                  <label className="custom-toggle mb-0">
                    <input
                      type="checkbox"
                      id="ring_group_forward_enabled"
                      name="ring_group_forward_enabled"
                      checked={formData.ring_group_forward_enabled}
                      onChange={handleChange}
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off="Off"
                      data-label-on="On"
                    />
                  </label>
                </div>
              </Col>
            </Row>

            {/* Conditional Fields */}
            <Row className="mb-3">
              <Col md={formData.ring_group_missed_call_app === "email" ? 3 : 3}>
                <Form.Group>
                  <Form.Label>Missed Call</Form.Label>
                  <Input
                  type="select"
                    name="ring_group_missed_call_app"
                    value={formData.ring_group_missed_call_app}
                    onChange={handleChange}
                  >
                    {missedCallOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Input>
                </Form.Group>
              </Col>

              {formData.ring_group_missed_call_app === "email" && (
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="ring_group_missed_call_email_data"
                      value={formData.ring_group_missed_call_email_data}
                      onChange={handleChange}
                      placeholder="Enter email address"
                    />
                  </Form.Group>
                </Col>
              )}
              {showForwardField && (<Col md={6}>
                  <Form.Group>
                    <Form.Label>Ring Group Forward Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="ring_group_forward_destination"
                      value={formData.ring_group_forward_destination}
                      onChange={handleChange}
                      placeholder="Enter forward number"
                    />
                  </Form.Group>
                </Col>)}
            </Row>
            {/* Additional Settings */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Forward Toll Allow</Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_forward_toll_allow"
                    value={formData.ring_group_forward_toll_allow}
                    onChange={handleChange}
                    placeholder="Enter toll allow"
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Context</Form.Label>
                  <Form.Control
                    type="text"
                    name="ring_group_context"
                    value={formData.ring_group_context}
                    onChange={handleChange}
                    placeholder="Enter context"
                    disabled
                    style={{
                      backgroundColor: isDark ? "#000000ff" : "#beb6b6ff",
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="ring_group_description"
                value={formData.ring_group_description}
                onChange={handleChange}
                placeholder="Enter description"
                rows={3}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <div className="d-flex align-items-center gap-3">
                <span>Enabled</span>
                <label className="custom-toggle mb-0">
                  <input
                    type="checkbox"
                    id="ring_group_enabled"
                    name="ring_group_enabled"
                    checked={formData.ring_group_enabled}
                    onChange={handleChange}
                  />
                  <span
                    className="custom-toggle-slider rounded-circle"
                    data-label-off="Off"
                    data-label-on="On"
                  />
                </label>
              </div>
            </Form.Group>

            {/* Action Buttons */}
            <div className="d-flex justify-content-between">
              <Button variant="danger" onClick={handleCancel}>
                Cancel
              </Button>
              <Button variant="success" onClick={handleSubmit}>
                {method.toUpperCase()} Ring Group
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default RinggroupAddEdit;
